import { PopcustomrestrictionComponent } from "./../../main/pages/popcustomrestriction/popcustomrestriction.component";
import { environment } from "../../../environments/environment";
import { User } from "./../models/user";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import { AuthenticationService } from "app/auth/service";
import { TokenStorageService } from "./token-storage.service";
import {
  HttpEvent,
  HttpResponse,
  HTTP_INTERCEPTORS,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from "@angular/common/http";
import { Inject, Injectable, InjectionToken } from "@angular/core";
import { tap } from "rxjs/operators";
import { sha512 } from "js-sha512";
import { CoreConfigService } from "@core/services/config.service";
import { ToastService } from "app/service/toast.service";
import { PopmsgComponent } from "app/main/pages/popmsg/popmsg.component";
const TOKEN_HEADER_KEY = "Token";
const nextTOKEN_HEADER_KEY = "nextToken";
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  key: any;
  tokenm: string;
  private: string;
  popres1: boolean = false;
  popres2: boolean = false;
  lang = "fr";
  constructor(
    private _tokenService: TokenStorageService,
    private authSrv: AuthenticationService,
    private _router: Router,
    private modalService: NgbModal,
    private toastr: ToastService,
    private _config: CoreConfigService
  ) {
    if (localStorage.getItem("currentUser"))
      this.user = JSON.parse(localStorage.getItem("currentUser"));
  }
  user: User;
  config = this._config.getConfig();
  generateString(x) {
    const characters = "abcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < x; i++) {
      result += characters.charAt(Math.floor(Math.random() * 36));
    }

    return result;
  }

  generateKey() {
    let key =
      this.generateString(8) +
      "-" +
      this.generateString(4) +
      "-" +
      this.generateString(4) +
      "-" +
      this.generateString(4) +
      "-" +
      this.generateString(12);

    this.key = key;
    return key;
  }

  crypt() {
    let passphrase = "RCq8@aSvhMn47s";
    let token = sha512
      .create()
      .update(this.key + passphrase)
      .hex();
    return token;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    let p;
    if (localStorage.getItem("Icognito")) {
      p = true;
    }
    this.tokenm = localStorage.getItem("new");
    const token = this._tokenService.getToken();
    const nextToken = this._tokenService.getnextToken();
    let fbToken = this._tokenService.getTokenFB();
    this.config.subscribe((x) => (this.lang = x.app.appLanguage));
    if (this.lang === null) {
      this.lang = "fr";
    }

    if (this.tokenm === null) {
      this.tokenm = "";
    }
    switch (req.url) {
      case environment.apiUrl + "/home/checkTransactionExpress":
        let tt = localStorage.getItem("tokenExpress");
        req = req.clone({
          headers: req.headers
            .set(TOKEN_HEADER_KEY, tt)
            .set("idempotencykey", this.generateKey())
            .set("key", this.crypt()),
        });
        break;
      case environment.apiUrl + "/inscription/getUserData":
        let tt2 = localStorage.getItem("tokenuser");
        req = req.clone({
          headers: req.headers
            .set(TOKEN_HEADER_KEY, token)
            .set("idempotencykey", this.generateKey())
            .set("key", this.crypt())
            .set("tokenuser", tt2),
        });
        break;
      case environment.apiUrl + "/postAuth/verifScodeIdentite":
        req = req.clone({
          headers: req.headers
            .set(TOKEN_HEADER_KEY, token)
            .set("idempotencykey", this.generateKey())
            .set("key", this.crypt())
            .set("lang", this.lang)
            .set("savebrowser", this.tokenm)
            .set("browser", "web"),
        });
        break;
      case environment.apiUrl + "/oauth":
        if (p) {
          if (fbToken === null) {
            req = req.clone({
              headers: req.headers
                .set("lang", this.lang)
                .set("idempotencykey", this.generateKey())
                .set("key", this.crypt())
                .set("browser", "web")
                .set("icognito", "true"),
            });
          } else {
            req = req.clone({
              headers: req.headers
                .set("tokenfirebase", fbToken)
                .set("lang", this.lang)
                .set("idempotencykey", this.generateKey())
                .set("key", this.crypt())
                .set("browser", "web")
                .set("icognito", "true"),
            });
          }
        } else {
          if (fbToken === null) {
            req = req.clone({
              headers: req.headers
                .set("lang", this.lang)
                .set("idempotencykey", this.generateKey())
                .set("key", this.crypt())
                .set("browser", "web"),
            });
          } else {
            req = req.clone({
              headers: req.headers
                .set("tokenfirebase", fbToken)
                .set("lang", this.lang)
                .set("idempotencykey", this.generateKey())
                .set("key", this.crypt())
                .set("browser", "web"),
            });
          }
        }

        break;
      default:
        if (token != null && nextToken != null) {
          req = req.clone({
            headers: req.headers
              .set(TOKEN_HEADER_KEY, token)
              .set(nextTOKEN_HEADER_KEY, nextToken)
              .set("idempotencykey", this.generateKey())
              .set("key", this.crypt())
              .set("lang", this.lang)
              .set("browser", "web"),
          });
        } else if (token != null) {
          req = req.clone({
            headers: req.headers
              .set(TOKEN_HEADER_KEY, token)
              .set("idempotencykey", this.generateKey())
              .set("key", this.crypt())
              .set("lang", this.lang)
              .set("browser", "web"),
          });
        }
        break;
    }

    return next.handle(req).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            if (event.body.popup) {
              let mod = this.modalService.open(PopmsgComponent, { backdrop: "static" });
              mod.componentInstance.msg = event.body.popup;
            }
            if (
              event.body.code === "04" ||
              event.body.code === "02" ||
              event.body.code === "05" ||
              event.body.code === "06" ||
              event.body.code === "19"
            ) {
              this.authSrv.logout();
              this._router.navigate(["/auth/login"]);
            }
            if (event.body.code === "09") {
              localStorage.setItem("etat", event.body.etat);
              localStorage.setItem("validation_sms", event.body.validation_sms);
              this.modalService.dismissAll();
              this._router.navigate(["/justification/doc"]);
            }
            if (event.body.code === "12") {
              this.modalService.dismissAll();
              this._router.navigate(["/justification/sms"]);
            }
            if (event.body.code === "03") {
              this.modalService.dismissAll();
              localStorage.removeItem("ses-token");
              localStorage.removeItem("currentUser");
              this._router.navigate(["/auth/verif-pin"]);
            }
            if (event.body.code === "17") {
              this.toastr.error(event.body.message);
              this.authSrv.logout();
              this._router.navigate(["/auth/login"]);
            }
            if (event.body.code === "20") {
              this.toastr.info(event.body.message);
            }
            if (event.body.code === "21") {
              if (!this.popres1) {
                this.popres1 = true;
                let modalRef = this.modalService.open(PopcustomrestrictionComponent, {
                  centered: true,
                  backdrop: "static",
                  size: "xl",
                });
                modalRef.componentInstance.data = {
                  title: "Compte non fonctionnel ! 🛠",
                  description:
                    "Un problème a été détecté sur votre compte. Veuillez nous contacter",
                };
                setTimeout(() => {
                  this.popres1 = false;
                }, 5000);
                if (!localStorage.getItem("block")) {
                  localStorage.setItem("block1", "1");
                }
              }
            }
            if (event.body.code === "22") {
              if (!this.popres2) {
                this.popres2 = true;
                let modalRef = this.modalService.open(PopcustomrestrictionComponent, {
                  centered: true,
                  backdrop: "static",
                  size: "xl",
                });
                modalRef.componentInstance.data = {
                  title: "Compte en attente de justification ! 🗎",
                  description:
                    "Données envoyées avec succès, nous allons traiter votre demande de justification dans les plus brefs délais. Le traitement prend entre 1 et 3 jours.",
                };
                setTimeout(() => {
                  this.popres2 = false;
                }, 5000);
                if (!localStorage.getItem("block")) {
                  localStorage.setItem("block2", "1");
                }
              }
            }
          }
        },
        (err: any) => {
          this.modalService.dismissAll();
          if (err instanceof HttpErrorResponse) {
            if (err.status !== 403) {
              return;
            }
          }
        }
      )
    );
  }
}

export const authInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
];
